import { Component, OnInit } from '@angular/core';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

@Component({
    selector: 'ea-subscription-completed-profile-page',
    templateUrl: './ea-subscription-completed-profile-page.component.html',
    styleUrls: ['./ea-subscription-completed-profile-page.component.scss'],
    standalone: false
})
export class EaSubscriptionCompletedProfilePageComponent implements OnInit {
  constructor(private subscribtionFacade: SubscriptionFacadeService) {}

  ngOnInit() {}
  next() {
    this.subscribtionFacade.nextStep();
  }
  prev() {
    this.subscribtionFacade.previousStep();
  }
}
